import React from 'react';
import CustomInput from '../../../../../../components/CustomInput';
import CustomSelect from '../../../../../../components/CustomSelect';

export default function PushTypeDriverInputs({
    data,
    flag,
    onChange,
    onSelectChange,
    selectOptions,
}) {
    return (
        <>
            <div className="form__item-wrapper">
                <CustomSelect
                    labelText="Driver"
                    name={`push_driver_id_${flag}`}
                    onChange={(value) => onSelectChange(value, flag)}
                    value={data[flag]?.push_driver_id}
                    options={selectOptions}
                />
            </div>
            {!data[flag]?.push_driver_id && (
                <>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`push_driver_name_${flag}`}
                            placeholder="Enter name"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.push_driver_name}
                            labelText="Name"
                            width="100%"
                            //   errorText={errors?.name}
                        />
                    </div>
                    <div className="form__item-wrapper">
                        <CustomInput
                            id={`push_driver_key_${flag}`}
                            placeholder="Enter key"
                            onInputChange={(e) => onChange(e, flag)}
                            inputValue={data[flag]?.push_driver_key}
                            labelText="Key"
                            width="100%"
                            //   errorText={errors?.client_id}
                        />
                    </div>
                </>
            )}
        </>
    );
}
